export default __webpack_public_path__ + "static/media/330_dummy2016-massagestudio01-mobile-de.75d11c6a.png";